import { render, staticRenderFns } from "./visitasUsersDetalle.vue?vue&type=template&id=9fc6fcfe"
import script from "./visitasUsersDetalle.vue?vue&type=script&lang=js"
export * from "./visitasUsersDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports